import {styledDiv} from '@packages/utilities/styled';
import {oneLineText} from './constants/Styles';

export default styledDiv(oneLineText);
